// ═══════════════════════════════════════════════════════════════
// config/deployment.ts – telepítés-specifikus címek egy helyen (S14 javítás)
//
// Korábban valós domainek, a VPS IP-címe, szervezetnevek és SZINKRON-
// KULCSOK voltak a komponensekbe írva, így a publikus JS-bundle-ből bárki
// kiolvashatta őket. Mostantól a build-környezet adja meg őket
// (frontend/.env.local – gitignore-ban van; minta: frontend/.env.example).
// Ha egy érték nincs megadva, a felület üres mezőt / beviteli mezőt mutat,
// a funkció (kézi URL-megadással) továbbra is elérhető.
// Titkot (kulcsot, jelszót) IDE SE írj: ami VITE_ változóban van, az a
// bundle-be kerül.
// ═══════════════════════════════════════════════════════════════

const env: Record<string, string | undefined> = ((import.meta as any).env || {}) as any;

const cleanUrl = (v?: string) => String(v || '').trim().replace(/\/+$/, '');

export const DEPLOYMENT = {
  /** Éles (felhős) portál / API gyökércím, pl. https://portal.example.hu */
  productionUrl: cleanUrl(env.VITE_PRODUCTION_URL),
  /** Saját VPS címe, pl. https://kozad.vps.example.hu */
  vpsUrl: cleanUrl(env.VITE_VPS_URL),
  /** A Szinkronizáció-kezelő alapértelmezett távoli API-címe */
  remoteApiUrl: cleanUrl(env.VITE_REMOTE_API_URL),
  /** A külső PHP/MySQL tükör felületének címe (pl. https://tarhely.example.hu/mirror/index.php) */
  mirrorDashboardUrl: cleanUrl(env.VITE_MIRROR_DASHBOARD_URL),
  /** A tükör tárhely megjelenített neve */
  mirrorLabel: String(env.VITE_MIRROR_LABEL || 'külső tárhely'),
  /** Opcionális: a Szinkronizáció-kezelőben kiemelt szervezet slugja */
  featuredSyncSlug: String(env.VITE_FEATURED_SYNC_SLUG || '').trim(),
  /** Opcionális: a kiemelt szervezet megjelenített neve */
  featuredSyncName: String(env.VITE_FEATURED_SYNC_NAME || '').trim(),
};

/** Egy URL hosztneve (üres, ha nem értelmezhető). */
export function hostOf(url?: string): string {
  try { return url ? new URL(url).hostname : ''; } catch { return ''; }
}

/** Igaz, ha a böngésző épp a megadott telepítés hosztján fut. */
export function isOnHost(url?: string): boolean {
  const h = hostOf(url);
  return !!h && typeof window !== 'undefined' && window.location.hostname === h;
}

/** Igaz, ha az `url` a `base` telepítésre mutat. */
export function pointsTo(url: string, base?: string): boolean {
  const h = hostOf(base);
  return !!h && hostOf(url) === h;
}
